/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:absolute;top:47px;left:0;height:25px;width:100%;z-index:3}.marker-active[_ngcontent-%COMP%]   .comment[_ngcontent-%COMP%]:not(.comment-marker){opacity:.5}.comment[_ngcontent-%COMP%]{position:absolute;top:0;width:15px;height:15px;transition:opacity .3s ease-in-out}.comment-marker[_ngcontent-%COMP%]{width:25px;height:25px;cursor:move}media-image[_ngcontent-%COMP%]{display:block;width:100%;height:100%}"];
export { styles as styles };
